// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageContent-module--wrapper--31nTx","image":"ImageContent-module--image--e4GVL"};